export default {
  SET_donation_form(state, payload) {
    state.donation_form = payload;
  }
};
